import React from 'react';
import PropTypes from 'prop-types';
import { trackElement } from '@nexus/fff-analytics';

import { links, notSubscribedLinks, activateMembership } from './boxButtonLinks';
import { NOT_SUBSCRIBED } from './boxStatusId';

const QuickLinks = ({ statusId, isChallenge }) => {
  const isntSubscribed = statusId === NOT_SUBSCRIBED;
  const boxLinks = isntSubscribed ? notSubscribedLinks : links;
  return (
    <div className="buttons-container">
      {isntSubscribed && !isChallenge && (
        <a
          href={activateMembership.href}
          type="button"
          className="mybox-membership-button"
        >
          {activateMembership.label}
        </a>
      )}
      {boxLinks.map(({ href, label }) => (
        <a
          key={href}
          href={href}
          onClick={() => trackElement(`${label} - BOX STATUS`)}
          type="button"
          className="mybox-button"
        >
          {label}
        </a>
      ))}
    </div>
  );
};

QuickLinks.defaultProps = {
  statusId: '',
  isChallenge: false,
};

QuickLinks.propTypes = {
  statusId: PropTypes.string,
  isChallenge: PropTypes.bool,
};

export default QuickLinks;
